// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { initSentryClient } from '@pickleballinc/config/sentry-next';
import * as Sentry from '@sentry/nextjs';

import { SENTRY_CONFIG } from '../sentry.config';

initSentryClient({
	app: 'brackets',
	sentryConfig: {
		...SENTRY_CONFIG,
		dsn: ''
	}
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
